
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cell-bio",
      function () {
        return require("private-next-pages/cell-bio/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cell-bio"])
      });
    }
  